import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import RiskWidget from '../../components/riskWidget';
import DashboardPopover from '../../../components/Popover';

const ProveranceRisk = ({ data, loadingData }) => {
  const { t } = useTranslation();

  const selectOptions = useMemo(() => {
    if (data && data.graph) {
      return Object.keys(data.graph).sort((a, b) => b - a).map((d) => ({
        value: d,
        label: d,
      }));
    }
    return [];
  }, [data]);

  const metrics = useMemo(() => {
    if (data && data.data && typeof data.participantsAssessed === 'number') {
      const values = Object.values(data.data);
      return [
        {
          key: 'sitesEvaluated',
          label: 'Participants Assessed',
          value: data.participantsAssessed || 0,
        },
        {
          key: 'riskScore',
          label: t('Assessment Score'),
          value: values[values.length - 1] || 0,
          type: 'riskScoreSupplyChain',
        },
      ]
    }
    return [];
  }, [data, t]);

  return (
    <RiskWidget
      t={t}
      title={t('Provenance Risk')}
      selectOptions={selectOptions}
      metricsItems={metrics}
      headerLabel="Included Mine Sites"
      headerValue={Number(data?.assessedMineSites || 0).toLocaleString('en-us')}
      data={data ? (data?.graph || {}) : {}}
      loading={loadingData}
      tooltip={(
        <DashboardPopover
          title={t('Provenance Risk')}
          body={t('Average risk score for all mine sites included in this supply chain.')}
        />
      )}
    />
  );
};

export default ProveranceRisk;
